// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3Awva":[function(require,module,exports,__globalThis) {
var _common = require("./common");
var trans;
$("document").ready(function() {
    translatePage();
    initClickListeners();
    window.onclick = function(event) {
        if (!event.target.matches('.dropbtn')) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for(i = 0; i < dropdowns.length; i++){
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) openDropdown.classList.remove('show');
            }
        }
    };
    setActiveList();
    $(window).scroll(function() {
        setActiveList();
    });
});
function setActiveList() {
    var windowPos = $(window).scrollTop() + 90;
    $('.stSection li a[href^="#"]').each(function() {
        var currentLink = $(this);
        if ($(currentLink.attr("href")).length > 0) {
            var refElement = $(currentLink.attr("href"));
            if (refElement.position().top <= windowPos && refElement.position().top + refElement.height() + $(".stSection").height() > windowPos) {
                $('.stSection li a').removeClass("active");
                currentLink.addClass("active");
            } else currentLink.removeClass("active");
        }
    });
}
function openNav() {
    document.getElementById("closeNav").style.display = "block";
    var sidePanel = document.getElementById("resTopnav");
    sidePanel.style.display = "block";
}
function initClickListeners() {
    myTopnav.querySelector('.icon').addEventListener('click', function() {
        openNav();
    });
    btnTranslate.addEventListener('click', function() {
        showDropdown();
    });
    aEn.addEventListener('click', function() {
        translatePage('en');
    });
    aEs.addEventListener('click', function() {
        translatePage('es');
    });
    document.getElementById('closeNav').addEventListener('click', function() {
        closeNav();
    });
// var offset = $('header').outerHeight();
// console.log("header: " + offset);
// $('.stSection li').find('a[href^=""]').click(function (event) {
//   event.preventDefault();
//   var anchorId = $(this).attr('href');
//   if (anchorId.length > 1 && $(anchorId).length > 0) {
//     //var target = $(anchorId).offset().top - offset;
//   }
//   else{
//     //var target = 0;
//   }
// });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
function closeNav() {
    var sidePanel = document.getElementById("resTopnav");
    sidePanel.style.display = "none";
// sidePanel.style.width = "0";
// sidePanel.style.overflow = "hidden";
}
var language = {
    eng: {
        Chat: "Chat",
        Feat: "Features",
        Download: "Download",
        About: "About",
        idiom: 'En',
        tMessage: 'Text Messages',
        aMessages: 'Voice Messages',
        vMessages: 'Photo/Video Messages',
        friends: 'Friends',
        status: 'Status Update',
        groupChats: 'Group Chats',
        notif: 'Manage Notifications',
        devices: 'Supported devices',
        register: 'How to Register',
        addRadio: 'Add Radios',
        security: 'Secure Messaging',
        ad: 'Advertisements',
        contact: 'Contact Us',
        meta: 'ChatMurcianys\'s texting features for both radio owners and users',
        p1: 'Send free text messages around the world for free*.',
        p2: '*Data charges may apply. Contact your provider for details.',
        p3: 'Save on typing and record a voice message. There is no time limit of your voice message!',
        p4: "Upload videos of any length and send to your contacts in ChatMurcianys. You can also send imagesof any type such as: JPEG, GIF, and PNG. ChatMurcianys offers you GIFs to make text messaging moreinteresting.",
        p5: 'Meet new people in ChatMurcianys. Once you create an account, you will be able to search for people by their name or email* and send them a friend request. Other people may also search for you using your name. Once a friend request is accepted, you can chat with them privately or invite them to a group chat.',
        p6: '*Email addresses are not shared with anyone. You may only search for someone through their email if that person shared their email with you.',
        p7: 'In ChatMurcianys you can post your day to day special moments and share them with your friends, group members, and any public chat you manage. You can share videos, photos, and audios to your status without any time limits. You can remove your status or wait until it expires in 24 hours.',
        p8: 'Create a group chat with an unlimited amount of people. Give the group a name and a description. You can share text messages, photos, and videos without limits of any kind. Easily invite anyone to join. If you are invited to a group chat, you can easily choose to leave or join with just a click of a button.',
        p9: 'We understand that some chats can get a bit chatty and flood your phone with notifications. With ChatMurcianys you can manage the notifications you receive by heading over to your settings. You can also turn on or off notifications for each individual chat.',
        p10: 'Use ChatMurcianys on any Android device such as phones and tablets by  <a href="http://tinyurl.com/chatmurcianys" target="_blank">downloading the app</a> on the Google Play Store. You may also visit us on the web at <a href="chat.html">chatmurcianys.com/chat</a>.',
        p11: 'To start using ChatMurcianys, you need to register using any email address or phone number. The method you choose to register with will not be shared with anyone. The name you provide when you register will be used to identify you. Providing a profile photo is optional.',
        p12: 'If you are the owner of a radio station and would like to add it to our application you may do so by visiting <a href="addRadio.html">chatmurcianys.com/addRadio</a> or  <a href="http://tinyurl.com/chatmurcianys" target="_blank">downloading the app</a> on  the Google Play Store. Please make sure you are either the owner of the radio or have  permission from the owner before doing so.',
        p13: 'In order to keep your information secure, ChatMurcianys will not share your email or phone number with anyone. You have full control over the messages you send. Once you delete a message, it is gone forever. We do not keep any messages you send unless you choose to do so to use on the web. We do not interfere with the messages you choose to send or share. Please be sure to only message with people whom you trust and know well.',
        p14: 'ChatMurcianys is able to keep its services free by displaying ads of your devices. You are free to report or block any advertisements you find inappropriate. If you are interested in advertising with us, email us at <a href="mailto:info@chatmurcianys.com">info@chatmurcianys.com</a>',
        p15: 'Feel free to reach out to us with any suggestions or concerns to <a href="mailto:info@chatmurcianys.com">info@chatmurcianys.com</a>'
    },
    es: {
        Chat: "Chat",
        Feat: "Funciones",
        Download: "Descargar",
        About: "Sobre",
        idiom: "Es",
        tMessage: 'Mensajes de Texto',
        aMessages: 'Mensajes de Voz',
        vMessages: 'Mensajes de Foto/Video',
        friends: 'Amistades',
        status: "Actualizaci\xf3n de Estado",
        groupChats: 'Chats en Grupo',
        notif: 'Administrar notificaciones',
        devices: 'Dispositivos Compatibles',
        register: "C\xf3mo Registrarse",
        addRadio: "A\xf1adir Radios",
        security: "Mensajer\xeda segura",
        ad: 'Anuncios Publicitiarios',
        contact: 'Contactanos',
        meta: "Las funciones de texto de ChatMurcianys para los due\xf1os de radio y usuarios",
        p1: "Env\xeda mensajes de texto gratis a todo el mundo gratis *.",
        p2: "* Se pueden aplicar cargos por datos. Contacta con tu proveedor para m\xe1s detalles.",
        p3: "Ahorre escribiendo y grabe un mensaje de voz. \xa1No hay l\xedmite de tiempo para su mensaje de voz!",
        p4: "Sube videos de cualquier duraci\xf3n y env\xedalos a tus contactos en ChatMurcianys. Tambi\xe9n puedes enviar im\xe1genes de cualquier tipo, como: JPEG, GIF y PNG. ChatMurcianys te ofrece GIFs para que los mensajes de texto sean m\xe1s interesantes.",
        p5: "Conoce gente nueva en ChatMurcianys. Una vez que crees una cuenta, podr\xe1s buscar personas por su nombre o correo electr\xf3nico* y enviarles una solicitud de amistad. Otras personas tambi\xe9n pueden buscarte usando tu nombre. Una vez que se acepta una solicitud de amistad, puedes chatear con ellos en privado o invitarlos a un chat grupal.",
        p6: "*Las direcciones de correo electr\xf3nico no se comparten con nadie. Solo puedes buscar a alguien a trav\xe9s de su correo electr\xf3nico si esa persona comparti\xf3 su correo electr\xf3nico contigo.",
        p7: "En ChatMurcianys puedes publicar tus momentos especiales del d\xeda a d\xeda y compartirlos con tus amigos, miembros del grupo y cualquier chat p\xfablico que administres. Puedes compartir videos, fotos y audios a tu estado sin l\xedmites de tiempo. Puedes eliminar tu estado o esperar hasta que caduque en 24 horas.",
        p8: "Crea un chat grupal con una cantidad ilimitada de personas. Dale al grupo un nombre y una descripci\xf3n. Puedes compartir mensajes de texto, fotos y videos sin l\xedmites de ning\xfan tipo. Invita f\xe1cilmente a cualquiera a unirse. Si te invitan a un chat grupal, puedes elegir f\xe1cilmente abandonar o unirte con solo hacer clic en un bot\xf3n.",
        p9: "Entendemos que algunos chats pueden ser muy activos e inundar tu tel\xe9fono con notificaciones. Con ChatMurcianys puedes administrar las notificaciones que recibes dirigi\xe9ndote a tu configuraci\xf3n. Tambi\xe9n puedes activar o desactivar las notificaciones para cada chat individual.",
        p10: 'Utiliza ChatMurcianys en cualquier dispositivo Android, como tel\xe9fonos y tabletas, <a href="http://tinyurl.com/chatmurcianys" target="_blank"> descargando la aplicaci\xf3n </a> en Google Play Store. Tambi\xe9n puedes visitarnos en la web en <a href="chat.html"> chatmurcianys.com/chat </a>.',
        p11: "Para comenzar a usar ChatMurcianys, debes registrarte con cualquier direcci\xf3n de correo electr\xf3nico o n\xfamero de tel\xe9fono. El m\xe9todo con el que elijas registrarte no se compartir\xe1. El nombre que proporciones cuando te registres se utilizar\xe1 para identificarte. Proporcionar una foto de perfil es opcional.",
        p12: 'Si eres propietario de una estaci\xf3n de radio y deseas agregarla a nuestra aplicaci\xf3n, puedes hacerlo visitando <a href="addRadio.html"> chatmurcianys.com/addRadio </a> o <a href = "http : //tinyurl.com/chatmurcianys "target =" _ blank "> descargando la aplicaci\xf3n </a> en Google Play Store. Aseg\xfarate de ser el propietario de la radio o tener permiso del propietario antes de hacerlo.',
        p13: "Para mantener tu informaci\xf3n segura, ChatMurcianys no compartir\xe1 tu correo electr\xf3nico o n\xfamero de tel\xe9fono. Tienes control total sobre los mensajes que env\xedas. Una vez que eliminas un mensaje, desaparece para siempre. No guardamos ning\xfan mensaje que se env\xede a menos que elijas hacerlo para usar en la web. No interferimos con los mensajes que eliges enviar o compartir. Aseg\xfarate de enviar mensajes solo a las personas en quienes conf\xedas y conoces bien.",
        p14: 'ChatMurcianys puede mantener sus servicios gratuitos al mostrar anuncios en tus dispositivos. Usted es libre de informar o bloquear cualquier publicidad que considere inapropiada. Si tiene inter\xe9s en anunciarse con nosotros, env\xedanos un correo electr\xf3nico a <a href="mailto:info@chatmurcianys.com">info@chatmurcianys.com</a>',
        p15: 'No dudes en comunicarte con nosotros con cualquier sugerencia o inquietud a <a href="mailto:info@chatmurcianys.com">info@chatmurcianys.com</a>'
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        if (lang.includes("es")) {
            if (trans && trans.idiom == 'Es') return;
            trans = language.es;
            document.getElementsByTagName('html')[0].setAttribute('lang', "es");
            var langs = langDropdown.querySelectorAll('a');
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            (0, _common.setCookie)('lang', 'es', 365);
        } else {
            if (trans && trans.idiom == 'En') return;
            trans = language.eng;
            document.getElementsByTagName('html')[0].setAttribute('lang', "en");
            var langs = langDropdown.querySelectorAll('a');
            langs[0].className += " set";
            langs[1].className = langs[1].className.replace(" set", "");
            (0, _common.setCookie)('lang', 'en', 365);
        }
        translate = true;
    } else if ((0, _common.getCookie)('lang') != "") {
        if ((0, _common.getCookie)('lang').includes('es')) {
            trans = language.es;
            document.getElementsByTagName('html')[0].setAttribute('lang', "es");
            var langs = langDropdown.querySelectorAll('a');
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)('lang', 'es', 365);
        } else trans = language.eng;
    } else if (navigator.language && navigator.language.includes("es")) {
        trans = language.es;
        document.getElementsByTagName('html')[0].setAttribute('lang', "es");
        var langs = langDropdown.querySelectorAll('a');
        langs[0].className = langs[0].className.replace(" set", "");
        langs[1].className += " set";
        translate = true;
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        navChat.textContent = trans.Chat;
        navFeat.textContent = trans.Feat;
        navDownload.textContent = trans.Download;
        navAbout.textContent = trans.About;
        resChat.textContent = trans.Chat;
        resFeat.textContent = trans.Feat;
        resDownload.textContent = trans.Download;
        resAbout.textContent = trans.About;
        var titles = document.querySelectorAll('h2');
        titles[0].textContent = trans.tMessage;
        titles[1].textContent = trans.aMessages;
        titles[2].textContent = trans.vMessages;
        titles[3].textContent = trans.friends;
        titles[4].textContent = trans.status;
        titles[5].textContent = trans.groupChats;
        titles[6].textContent = trans.notif;
        titles[7].textContent = trans.devices;
        titles[8].textContent = trans.register;
        titles[9].textContent = trans.addRadio;
        titles[10].textContent = trans.security;
        titles[11].textContent = trans.ad;
        titles[12].textContent = trans.contact;
        var aShortCuts = document.querySelectorAll('.stSection a');
        aShortCuts[0].textContent = trans.tMessage;
        aShortCuts[1].textContent = trans.aMessages;
        aShortCuts[2].textContent = trans.vMessages;
        aShortCuts[3].textContent = trans.friends;
        aShortCuts[4].textContent = trans.status;
        aShortCuts[5].textContent = trans.groupChats;
        aShortCuts[6].textContent = trans.notif;
        aShortCuts[7].textContent = trans.devices;
        aShortCuts[8].textContent = trans.register;
        aShortCuts[9].textContent = trans.addRadio;
        aShortCuts[10].textContent = trans.security;
        aShortCuts[11].textContent = trans.ad;
        aShortCuts[12].textContent = trans.contact;
        document.head.querySelector('meta[name="description"]').textContent = trans.meta;
        var pList = document.querySelectorAll('.rlMar p');
        pList[0].innerHTML = trans.p1;
        pList[1].innerHTML = trans.p2;
        pList[2].innerHTML = trans.p3;
        pList[3].innerHTML = trans.p4;
        pList[4].innerHTML = trans.p5;
        pList[5].innerHTML = trans.p6;
        pList[6].innerHTML = trans.p7;
        pList[7].innerHTML = trans.p8;
        pList[8].innerHTML = trans.p9;
        pList[9].innerHTML = trans.p10;
        pList[10].innerHTML = trans.p11;
        pList[11].innerHTML = trans.p12;
        pList[12].innerHTML = trans.p13;
        pList[13].innerHTML = trans.p14;
        pList[14].innerHTML = trans.p15;
    }
}

},{"./common":"jYzpo"}]},["3Awva"], "3Awva", "parcelRequire460e", {})

//# sourceMappingURL=features.50b66150.js.map
